/**
 * Assistant Node Component
 * AI assistant node that can execute tasks
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Bot } from 'lucide-react';
import styles from './Nodes.module.css';

export const AssistantNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.assistantNode} ${selected ? styles.selected : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
      />
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#2563eb' }}>
          <Bot size={16} color="white" />
        </div>
        <div className={styles.nodeDetails}>
          <span className={styles.nodeLabel}>{data.label || 'Assistant'}</span>
          {data.stateId && (
            <span className={styles.nodeSubtitle}>{data.stateId}</span>
          )}
        </div>
      </div>
      {/* Status indicator - green dot */}
      {data.isConnected && (
        <span className={styles.statusIndicator} />
      )}
      <Handle
        type="source"
        position={Position.Right}
        className={styles.handle}
      />
    </div>
  );
});

AssistantNode.displayName = 'AssistantNode';

